var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgLogout = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 20.25a.75.75 0 01-.75.75H4.5A1.5 1.5 0 013 19.5v-15A1.5 1.5 0 014.5 3h5.25a.75.75 0 110 1.5H4.5v15h5.25a.75.75 0 01.75.75zm10.28-8.78l-3.75-3.75a.75.75 0 10-1.06 1.06l2.47 2.47H9.75a.75.75 0 100 1.5h8.69l-2.47 2.47a.75.75 0 101.06 1.06l3.75-3.75a.747.747 0 000-1.06z",
  fill: "#00163F"
})));
export default SvgLogout;